import Tween from "tween.ts"
import Animation from "../../../../src/animation/Animation";


export default class ReduceOpacityAnim extends Animation {
  constructor(Element, onComp: () => void, delay = 0) {
    super();
    new Tween.Tween(Element)
      .to({ alpha: 0 }, 1500)
      .easing(Tween.Easing.Linear.None)
      .delay(delay)
      .onComplete(() => onComp())
      .start();
  }
}